// ./store/slices/docGenSlice.ts

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface DocGenState {
    isDocGen: boolean;
    docGenBuffer: string;
}

const initialState: DocGenState = {
    isDocGen: false,
    docGenBuffer: '',
};

const docGenSlice = createSlice({
    name: 'docGen',
    initialState,
    reducers: {
        startDocGen(state, action: PayloadAction<string>) {
            state.isDocGen = true;
            state.docGenBuffer = action.payload;
        },
        appendToDocGenBuffer(state, action: PayloadAction<string>) {
            state.docGenBuffer += action.payload;
        },
        resetDocGen(state) {
            state.isDocGen = false;
            state.docGenBuffer = '';
        },
    },
});

export const { startDocGen, appendToDocGenBuffer, resetDocGen } = docGenSlice.actions;
export default docGenSlice.reducer;
